import { Exception, ExceptionCode } from "@konv/exceptions";
import { BaseStorage } from "@/storage/BaseStorage";
import { SaiposAPI } from "@/api/SaiposAPI";

const SAIPOS_AUTH_KEY = "of-saipos-tk";

const serverTokenCache = new Map();

export class SaiposAuth {
  constructor(configurations) {
    this.storeId = configurations?.storeId;

    this.client = new SaiposAPI({
      environment: process.env.SAIPOS_ENVIRONMENT || null,
      partnerId: configurations?.partnerId,
      storeId: configurations?.storeId,
      secret: configurations?.secret,
    });

    if (typeof window !== "undefined") {
      this.cache = new BaseStorage({ key: SAIPOS_AUTH_KEY });
    }
  }

  async removeToken() {
    if (this.cache) {
      this.cache.setData(null);
    } else {
      serverTokenCache.delete(this.storeId);
    }
  }

  async getToken() {
    const cacheValue = this.cache
      ? this.cache.getData()
      : serverTokenCache.get(this.storeId) ?? null;

    if (cacheValue) return cacheValue;

    const tokenResponse = await this.client.getToken();

    if (tokenResponse.isError()) {
      const errorMessage = `Falha na autenticação - ${tokenResponse.getErrors()[0]}`;
      throw new Error(errorMessage);
    }

    const { token } = tokenResponse.getData({});

    if (!token) {
      throw new Error("Falha na autenticação - Não foi possível obter o token");
    }

    console.log("[SAIPOS][%s][INFO] Token gerado com sucesso", this.storeId);

    if (this.cache) {
      this.cache.setData(token);
    } else {
      serverTokenCache.set(this.storeId, token);
    }

    return token;
  }
}
